<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerAgencies">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(agency)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { AgencyService } from "../../../services/AgencyService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "AgencyPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      agency: null,
      agencyService: new AgencyService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerAgencies() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.agency) {
        return {
          title: this.agency.value,
          id: this.ids[0],
          status: this.getStatus(this.agency.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.agency) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.agency.code,
            },
          ],
          [
            {
              title: this.$t("agencyValue"),
              text: this.agency.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.agency) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.agency.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.agency.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.agency.createdAt) +
                " " +
                getAMorPM(this.agency.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.agency.lastUpdated) +
                " " +
                getAMorPM(this.agency.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.agency)
        : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getAgency();
      } catch (e) {
        this.hasError = true;
      }
    },
    getAgency() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.agencyService.get(this.ids[0]).then((res) => {
          this.agency = res.data;
          this.loading = false;
        });
      }
      this.agency = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.agency);
    },
    deletePanel() {
      this.$emit("delete", this.agency);
    },
    showHistoryPanel() {
      this.$emit("history", this.agency);
    },
  },
};
</script>

<style scoped></style>
